import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-credit-report-image-panels',
  templateUrl: './credit-report-image-panels.component.html',
  styleUrls: ['./credit-report-image-panels.component.scss']
})
export class CreditReportImagePanelsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
